import { render, staticRenderFns } from "./WelcomeAudioRecorder.vue?vue&type=template&id=14c4908e&scoped=true&"
import script from "./WelcomeAudioRecorder.vue?vue&type=script&lang=js&"
export * from "./WelcomeAudioRecorder.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeAudioRecorder.vue?vue&type=style&index=0&id=14c4908e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c4908e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
